import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
} from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { termsOfPaymentSchema } from "../../schemas/termsOfPaymentSchema";
import { addTermsOfPayment } from "../../../../api/termsOfPaymentApi";
import { Controller } from "react-hook-form";
import { StyledLink } from "../../../../common/components/Title/styles";
import { Autocomplete, TextField } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { getAllModeOfPayments } from "../../../../api/modeOfPaymentApi";
const AddTermsOfPaymentDialog = ({
  openAddTermsOfPayment,
  handleCloseAddTermsOfPayment,
  currentTermsOfPayment,
  fetchTermsOfPayments,
  handleOpenAlert,
  handleSetAlertMessage,
  isTabBeforeDesign,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(termsOfPaymentSchema),
  });

  const [modeOfPayment, setModeOfPayment] = useState([]);
  const [firstPartCount, setFirstPartCount] = useState([0]);

  useEffect(() => {
    const fetchModeOfPayment = async () => {
      const response = await getAllModeOfPayments();
      setModeOfPayment(response);
    };

    fetchModeOfPayment();

    let defaultValues = {};
    defaultValues.type = isTabBeforeDesign ? 0 : 1;
    reset({ ...defaultValues });
  }, [isTabBeforeDesign, reset]);

  const paymentSchedulesData = watch("paymentSchedules");

  const handleIncrementFirstPartCount = () => {
    if (firstPartCount.length < 3) {
      setFirstPartCount((prev) => [...prev, prev[prev.length - 1] + 1]);
    }
  };

  const handleDecrementFirstPartCount = (index) => {
    if (firstPartCount.length > 1) {
      const list = firstPartCount;
      list.splice(index, 1);
      setFirstPartCount(list);
    }

    const filteredData = paymentSchedulesData.filter(
      (element, idx) => idx !== index
    );
    console.log(filteredData);
    setValue("paymentSchedules", filteredData);
  };

  const submitAddTermsOfPayment = async (values) => {
    console.log(values);
    const response = await addTermsOfPayment(values);
    if (response.data.code != null) {
      handleSetAlertMessage(response.data.message);
      handleOpenAlert();
    } else {
      reset();
      setFirstPartCount([0]);
      handleCloseAddTermsOfPayment();
      fetchTermsOfPayments();
    }
  };

  const firstPartStepsDynamic = [
    {
      id: 0,
      name: "Before F2F Consult",
      step: 0,
    },
    {
      id: 1,
      name: "Before Scanning",
      step: 1,
    },
    {
      id: 2,
      name: "Before Designing",
      step: 2,
    },
    {
      id: 3,
      name: "No Payment Required",
      step: 5,
    },
  ];

  const firstPartStepsDynamicV2 = [
    {
      id: 0,
      name: "Before F2F Consult",
      step: 0,
    },
    {
      id: 1,
      name: "Before Scanning",
      step: 1,
    },
    {
      id: 2,
      name: "Before Designing",
      step: 2,
    },
  ];

  const intervalTypeOptions = [
    {
      id: 0,
      name: "Weeks",
      value: 7,
    },
    {
      id: 1,
      name: "Months",
      value: 31,
    },
  ];

  const secondPartSteps = [
    {
      id: 0,
      name: "Balance Divided By Number of Sets",
      step: 3,
    },
    {
      id: 1,
      name: "Balance Divided By Number of Payments",
      step: 4,
    },
    {
      id: 2,
      name: "No Payment Required",
      step: 5,
    },
  ];

  const paymentTypes = [
    {
      id: 0,
      name: "Online payment",
      paymentType: 0,
    },
    {
      id: 1,
      name: "Manually collected",
      paymentType: 1,
    },
  ];
  return (
    <div>
      <StyledDialog
        open={openAddTermsOfPayment}
        onClose={() => {
          reset();
          setFirstPartCount([0]);
          handleCloseAddTermsOfPayment();
        }}
        width="1200px"
        maxWidth="lg"
      >
        <DialogTitle>Add Terms Of Payment</DialogTitle>
        <form onSubmit={handleSubmit(submitAddTermsOfPayment)}>
          <DialogContent dividers>
            <StyledTextField
              variant="outlined"
              label="Name"
              InputLabelProps={{
                shrink: true,
              }}
              error={errors.name}
              helperText={errors.name?.message}
              {...register("name")}
            />
            <Controller
              control={control}
              name={`modeOfPaymentId`}
              render={({ field: { onChange }, fieldState: { error } }) => (
                <Autocomplete
                  options={modeOfPayment}
                  disabled={
                    watch(`paymentSchedules.${0}.step`) === 5 ? true : false
                  }
                  onChange={(_, val) => {
                    onChange(val?.id);
                  }}
                  getOptionLabel={(option) => option.name || option}
                  renderInput={(params) => (
                    <TextField
                      label="Mode of Payment"
                      {...params}
                      error={Boolean(error)}
                      FormHelperTextProps={{ variant: "standard" }}
                      helperText={error && error.message}
                    />
                  )}
                  renderOption={(props, option) => {
                    return (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    );
                  }}
                  sx={{ width: "250px", paddingBottom: "15px" }}
                />
              )}
            />
            {isTabBeforeDesign ? (
              <div
                style={{
                  border: "1px solid #d6d6d6",
                  padding: "10px",
                  borderRadius: "5px",
                  marginBottom: "20px",
                }}
              >
                <Typography
                  color="gray"
                  fontFamily="Inter"
                  fontSize={"13px"}
                  marginBottom={2}
                >
                  Payment schedule
                </Typography>
                {firstPartCount.map((item, index) => {
                  return (
                    <Grid key={item} container spacing={1}>
                      <Grid item xs={4}>
                        <Controller
                          control={control}
                          name={`paymentSchedules.${index}.step`}
                          render={({
                            field: { onChange },
                            fieldState: { error },
                          }) => (
                            <Autocomplete
                              options={
                                index === 0
                                  ? firstPartStepsDynamic
                                  : firstPartStepsDynamicV2
                              }
                              onChange={(_, val) => {
                                if (val?.step === 5) {
                                  const filteredData =
                                    paymentSchedulesData.filter(
                                      (element, idx) => idx === 0
                                    );
                                  filteredData[0].amountOrNumberOfSets = 0;
                                  filteredData[0].paymentType = null;
                                  setValue("paymentSchedules", filteredData);
                                  setValue("intervalValue", null);
                                  setValue(`modeOfPaymentId`, null);

                                  setFirstPartCount((prev) => [prev[0]]);
                                }
                                onChange(val?.step);
                              }}
                              getOptionLabel={(option) => option.name || option}
                              renderInput={(params) => (
                                <TextField
                                  label="Step"
                                  {...params}
                                  error={Boolean(error)}
                                  FormHelperTextProps={{ variant: "standard" }}
                                  helperText={error && error.message}
                                />
                              )}
                              renderOption={(props, option) => {
                                return (
                                  <li {...props} key={option.step}>
                                    {option.name}
                                  </li>
                                );
                              }}
                              sx={{ width: "100%" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <StyledTextField
                          sx={{ width: "100%" }}
                          variant="outlined"
                          label="Amount"
                          disabled={
                            watch(`paymentSchedules.${0}.step`) === 5
                              ? true
                              : false
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={
                            errors.paymentSchedules &&
                            errors.paymentSchedules[index]
                              ? errors.paymentSchedules[index]
                                  .amountOrNumberOfSets
                              : false
                          }
                          helperText={
                            errors.paymentSchedules &&
                            errors.paymentSchedules[index] &&
                            errors.paymentSchedules[index].amountOrNumberOfSets
                              ? errors.paymentSchedules[index]
                                  .amountOrNumberOfSets.message
                              : null
                          }
                          control={control}
                          {...register(
                            `paymentSchedules.${index}.amountOrNumberOfSets`
                          )}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <Controller
                          control={control}
                          name={`paymentSchedules.${index}.paymentType`}
                          render={({
                            field: { onChange },
                            fieldState: { error },
                          }) => (
                            <Autocomplete
                              options={paymentTypes}
                              onChange={(_, val) => {
                                onChange(val?.paymentType);
                              }}
                              disabled={
                                watch(`paymentSchedules.${0}.step`) === 5
                                  ? true
                                  : false
                              }
                              getOptionLabel={(option) => option.name || option}
                              renderInput={(params) => (
                                <TextField
                                  label="Payment Type"
                                  {...params}
                                  error={Boolean(error)}
                                  FormHelperTextProps={{ variant: "standard" }}
                                  helperText={error && error.message}
                                />
                              )}
                              renderOption={(props, option) => {
                                return (
                                  <li {...props} key={option.paymentType}>
                                    {option.name}
                                  </li>
                                );
                              }}
                              sx={{ width: "100%" }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        {firstPartCount.length > 1 ? (
                          <div
                            style={{
                              marginTop: "10px",
                              cursor: "pointer",
                              borderRadius: "30px",
                              padding: "10px",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              label="Delete"
                              onClick={() =>
                                handleDecrementFirstPartCount(index)
                              }
                              color="gray"
                            />
                          </div>
                        ) : null}
                      </Grid>
                    </Grid>
                  );
                })}
                <div
                  style={{
                    visibility:
                      watch(`paymentSchedules.${0}.step`) !== 5
                        ? "visible"
                        : "hidden",
                  }}
                >
                  <StyledLink
                    onClick={handleIncrementFirstPartCount}
                    theme="lightpurple"
                    type="submit"
                    disabled={
                      watch(`paymentSchedules.${0}.step`) === 5 ? true : false
                    }
                  >
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{ marginRight: "10px" }}
                    />
                    Add payment schedule
                  </StyledLink>
                </div>
              </div>
            ) : (
              <div
                style={{
                  border: "1px solid #d6d6d6",
                  padding: "10px",
                  borderRadius: "5px",
                  marginBottom: "20px",
                }}
              >
                <Typography
                  color="gray"
                  fontFamily="Inter"
                  fontSize={"13px"}
                  marginBottom={2}
                >
                  Payment schedule
                </Typography>
                <Grid key={999} container spacing={1}>
                  <Grid item xs={4}>
                    <Controller
                      control={control}
                      name={`paymentSchedules.0.step`}
                      render={({
                        field: { onChange },
                        fieldState: { error },
                      }) => (
                        <Autocomplete
                          options={secondPartSteps}
                          onChange={(_, val) => {
                            if (val?.step === 3) {
                              setValue(
                                `paymentSchedules.0.amountOrNumberOfSets`,
                                0
                              );
                            } else if (val?.step === 5) {
                              setValue(
                                `paymentSchedules.0.amountOrNumberOfSets`,
                                0
                              );
                              setValue(`modeOfPaymentId`, null);
                              setValue(`intervalValue`, 0);
                            }
                            onChange(val?.step);
                          }}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField
                              label="Step"
                              {...params}
                              error={Boolean(error)}
                              FormHelperTextProps={{ variant: "standard" }}
                              helperText={error && error.message}
                            />
                          )}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option.step}>
                                {option.name}
                              </li>
                            );
                          }}
                          sx={{ width: "100%" }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <StyledTextField
                      sx={{ width: "100%" }}
                      variant="outlined"
                      label="Number Of Payments"
                      disabled={
                        watch(`paymentSchedules.0.step`) === 5 ||
                        watch(`paymentSchedules.0.step`) === 3
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={
                        errors.paymentSchedules && errors.paymentSchedules[0]
                          ? errors.paymentSchedules[0].amountOrNumberOfSets
                          : false
                      }
                      helperText={
                        errors.paymentSchedules &&
                        errors.paymentSchedules[0] &&
                        errors.paymentSchedules[0].amountOrNumberOfSets
                          ? errors.paymentSchedules[0].amountOrNumberOfSets
                              .message
                          : null
                      }
                      control={control}
                      {...register(`paymentSchedules.0.amountOrNumberOfSets`)}
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name={`paymentSchedules.0.paymentType`}
                      render={({
                        field: { onChange },
                        fieldState: { error },
                      }) => (
                        <Autocomplete
                          options={paymentTypes}
                          disabled={watch(`paymentSchedules.0.step`) === 5}
                          onChange={(_, val) => {
                            onChange(val?.paymentType);
                          }}
                          getOptionLabel={(option) => option.name || option}
                          renderInput={(params) => (
                            <TextField
                              label="Payment Type"
                              {...params}
                              error={Boolean(error)}
                              FormHelperTextProps={{ variant: "standard" }}
                              helperText={error && error.message}
                            />
                          )}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option.paymentType}>
                                {option.name}
                              </li>
                            );
                          }}
                          sx={{ width: "100%" }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Controller
                      control={control}
                      name={`intervalType`}
                      render={({
                        field: { onChange },
                        fieldState: { error },
                      }) => (
                        <Autocomplete
                          options={intervalTypeOptions}
                          onChange={(_, val) => {
                            onChange(val?.value);
                          }}
                          disabled={watch(`paymentSchedules.0.step`) === 5}
                          getOptionLabel={(option) => option.name || option}
                          renderInput={(params) => (
                            <TextField
                              label="Interval Type"
                              {...params}
                              error={Boolean(error)}
                              FormHelperTextProps={{ variant: "standard" }}
                              helperText={error && error.message}
                            />
                          )}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option.value}>
                                {option.name}
                              </li>
                            );
                          }}
                          sx={{ width: "100%" }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <StyledTextField
                      variant="outlined"
                      type="number"
                      label="Interval Value"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={watch(`paymentSchedules.0.step`) === 5}
                      error={errors.intervalValue}
                      helperText={errors.intervalValue?.message}
                      {...register("intervalValue")}
                    />
                  </Grid>
                </Grid>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={() => {
                reset();
                setFirstPartCount([0]);
                handleCloseAddTermsOfPayment();
              }}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit">
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddTermsOfPaymentDialog;
